import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import classnames from "classnames";
import { Button, FloatingLabel, Form, FormControlProps } from "react-bootstrap";
import { useField } from "formik";
import { Trash } from "react-bootstrap-icons";
import { hexToRgba, rgbaToHex } from "../../../helpers";

interface IInputColorProps extends FormControlProps {
  name: string;
  className?: string;
  defaultColor?: string;
}

export default function InputColor({
  name,
  className,
  defaultColor,
  ...props
}: IInputColorProps) {
  const [field, , helpers] = useField(name);
  const [color, setColor] = useState(
    hexToRgba(field.value as string) || "rgba(0, 0, 0, 1)"
  );
  const [debouncedColor] = useDebounce(color, 300);

  useEffect(() => {
    const hexValue = rgbaToHex(debouncedColor);
    if (hexValue) helpers.setValue(hexValue);
  }, [debouncedColor]);

  useEffect(() => {
    const rgbaValue = hexToRgba(field.value as string);
    if (rgbaValue) setColor(rgbaValue);
  }, [field.value]);

  return (
    <div
      className={classnames("d-flex", {
        [className]: className,
      })}
    >
      <FloatingLabel
        label={props.placeholder}
        className={classnames("position-relative w-100")}
      >
        <Form.Control
          type="text"
          {...field}
          {...props}
          value={color}
          className="w-100 border-0 border-start border-bottom border-top rounded-0 rounded-start"
        />
        <div className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center rounded-1 p-2 h-100">
          <label
            className="rounded-1 border border-1 cursor-pointer"
            style={{ backgroundColor: color, width: "36px", height: "36px" }}
          >
            <input
              className="opacity-0"
              style={{ width: 0, height: 0 }}
              type="color"
              onChange={(e) =>
                setColor(hexToRgba(e.target.value) || "rgba(0, 0, 0, 1)")
              }
              value={rgbaToHex(color) || "#000000"}
            />
          </label>
        </div>
      </FloatingLabel>
      <Button
        variant=""
        className="border text-gray rounded-0 rounded-end px-3"
        onClick={() => helpers.setValue(defaultColor || "#16B054")}
      >
        <Trash style={{ fill: "#8B929A" }} />
      </Button>
    </div>
  );
}
